export const TED_ACCOUNT_INFO_SECTION_NAME = 'Minha Conta';

export const MENU_ID_PREFIX = 'side-nav-item-';
